// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"962":"32d6a84c","990":"13536623"}[chunkId] + ".chunk.js";
};